<template>
  <div class="checkbox checkbox-css">
    <input
      type="checkbox"
      :checked="isChecked"
      :disabled="disabled"
      :value="value"
      @change="event => onChange(event)"
    />
    <label @click="event => event.target.previousSibling.click()">
      <slot />
    </label>
  </div>
</template>

<script>
import { findIndex, isEqual } from 'lodash'

export default {
  name: 'TsCheckbox',
  model: {
    prop: 'checkedValue',
    event: 'change'
  },
  props: {
    value: {},
    checkedValue: {
      type: [Boolean,Array, Number],
      default: false
    },
    disabled: Boolean
  },
  computed: {
    isChecked() {
      return (
        (Array.isArray(this.checkedValue) &&
          findIndex(this.checkedValue, o => isEqual(o, this.value)) >= 0) ||
        this.checkedValue === true
      )
    }
  },
  methods: {
    onChange(event) {
      if (Array.isArray(this.checkedValue)) {
        let checkedValue = this.checkedValue

        if (event.target.checked) {
          checkedValue.push(this.value)
        } else {
          checkedValue.splice(checkedValue.indexOf(this.value), 1)
        }

        this.$emit('change', checkedValue)
      } else {
        this.$emit('change', event.target.checked)
      }
    }
  }
}
</script>
